import localStore, { AUTHORIZATION } from '@/store/local-store';
import axios, { AxiosResponse } from 'axios';

// 定义通用的响应接口
export interface StdResponse<T = any> extends AxiosResponse<T> {
    message: string
}

// 创建 Axios 实例，配置基础 URL 和超时时间
const coreAxios = axios.create({
    baseURL: '/api-core', // 用于统一接口前缀
    timeout: 60000, // 请求超时时间（60秒）
});


// 请求拦截器，用于在请求发送前统一处理
coreAxios.interceptors.request.use(
    config => {
        // 从本地localStore获取token
        config.headers.token = "579c0b005d4547de9f57ea9b6f984107";
        return config;
    },
    err => {
        console.log(err);
    }
)
// 响应拦截器，用于在响应返回后统一处理
coreAxios.interceptors.response.use(
    response => {
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        if (error.status === 401) {
            // 未授权登录
            localStore.clear();
        }
        return Promise.reject(error);
    }
)

const monixAxios = axios.create({
    baseURL: '/api',
    timeout: 60000
})

// 请求拦截器，用于在请求发送前统一处理
monixAxios.interceptors.request.use(
    config => {
        // 设置永久token
        config.headers.token = "579c0b005d4547de9f57ea9b6f984107";
        return config;
    },
    err => {
        console.log(err);
    }
)
// 响应拦截器，用于在响应返回后统一处理
monixAxios.interceptors.response.use(
    response => {
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        if (error.status === 401) {
            // 未授权登录
            localStore.clear();
        }
        return Promise.reject(error);
    }
)

const feedbackAxios = axios.create({
    baseURL: '/api-feedback',
    timeout: 60000,
})

feedbackAxios.interceptors.request.use(
    config => {
        // 从本地Cookie获取token
        let token = localStore.token;
        config.headers.token = token;
        return config;
    },
    err => {
        console.log(err);
    }
)
feedbackAxios.interceptors.response.use(
    response => {
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        console.log(err);

        if (error.statue === 401) {
            // 未授权登录
            // appStore.clear();
            // store.userStore.setIsLogin(false);
        }
        return Promise.reject(error);
    }
)


export { coreAxios, monixAxios, feedbackAxios };
